import React, { useMemo } from 'react';
import BreakDownHeader from '@/pages/dashboard/components/BreakDownHeader';
import { useIntl } from 'umi';

import './index.scss'
import { getTranslatedText } from './_utils/common';

type OptionType = {
  text: string;
  textCn: string;
  formatText: string;
  value: string;
}

interface CountriesPlatformRegionTabProps {
  children: React.ReactNode;
  changeData: (key: string, value: string) => void;
  [key: string]: any;
}

const CountriesPlatformRegionTab = ({
  children,
  props,
  changeData,
  ...restProps
}: CountriesPlatformRegionTabProps) => {
  const { config } = restProps || {};
  const { options: initOptions, defaultValue, dataKey } = config || {};
  const { locale, formatMessage } = useIntl();

  const options = useMemo(() => {
    const newOptions = initOptions.map((option: OptionType) => {
      const { text, textCn, formatText, value } = option;
      return {
        text: getTranslatedText(text, textCn, formatText, locale, formatMessage),
        value,
      };
    });

    return newOptions;
  }, [locale, initOptions, formatMessage]);

  return (
    <div className='dbd-countries-platform-region-tab'>
      <BreakDownHeader 
        options={options}
        defaultValue={defaultValue}
        onChange={(val: string) => {
          changeData(dataKey, val)
        }}
      />
      {
        // 保证是jsx数组，而不是其他类型数组
        React.Children.map(children, (child: any) => {
          return React.cloneElement(
            child,
          );
        })
      }
    </div>
  );
};

export default CountriesPlatformRegionTab;
